/* eslint-disable no-param-reassign */

import { useCallback } from 'react';
import { createCategoryId } from '../utils/categoryHelpers';

export const useCategoryNavigation = (
  setSelectedCategory,
  isScrollingProgrammatically,
  scrollTimeout
) => {
  const scrollToMobileCategory = useCallback((categoryName) => {
    const categoryId = createCategoryId(categoryName, 'mobile-category');
    const element = document.getElementById(categoryId);

    if (element) {
      const yOffset = -80;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: 'smooth'
      });
    }
  }, []);

  const scrollToDesktopCategory = useCallback(
    (categoryName, scrollableContentRef) => {
      const categoryId = createCategoryId(categoryName);
      const element = document.getElementById(categoryId);

      if (element && scrollableContentRef.current) {
        scrollableContentRef.current.scrollTo({
          top: element.offsetTop - 300,
          behavior: 'smooth'
        });
      }
    },
    []
  );

  const handleCategorySelect = useCallback(
    (categoryName, scrollableContentRef) => {
      setSelectedCategory(categoryName);
      isScrollingProgrammatically.current = true;

      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }

      if (window.innerWidth < 768) {
        scrollToMobileCategory(categoryName);
      } else {
        scrollToDesktopCategory(categoryName, scrollableContentRef);
      }

      // Reduced timeout to 800ms to match MenuNavigation
      scrollTimeout.current = setTimeout(() => {
        isScrollingProgrammatically.current = false;
      }, 800);
    },
    [setSelectedCategory, scrollToMobileCategory, scrollToDesktopCategory]
  );

  return {
    handleCategorySelect,
    scrollToMobileCategory,
    scrollToDesktopCategory
  };
};
